@if (!authState().isAuthenticated) {
<div class="login-container">
  <mat-card class="login-card">
    <a
      class="app-title"
      aria-label="zav cms"
    >
      <div class="logo"></div>
    </a>

    @if (inactivityService.wasAutoLoggedOut()) {
    <p class="auto-logout-message">{{ "auto_logout_message" | transloco }}</p>
    }

    <form
      [formGroup]="loginForm"
      autocomplete="off"
      novalidate
    >
      <mat-form-field>
        <mat-label>{{ "email-address" | transloco }}</mat-label>
        <input
          matInput
          formControlName="email"
          (keydown.enter)="sendLogin()"
        >
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "password" | transloco }}</mat-label>
        <input
          matInput
          type="password"
          formControlName="password"
          (keydown.enter)="sendLogin()"
        >
      </mat-form-field>

      <button
        mat-raised-button
        color="primary"
        (click)="sendLogin()"
      >{{ "login" | transloco }}</button>
    </form>
  </mat-card>
</div>
}